let actions = {
    doneNameAction({commit}, val) {
        commit('doneName', val)
    }
}

export default actions